import { Directive, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { ResizeObserver as ResizePolyfill } from '@juggle/resize-observer';

@Directive({ selector: '[appResizeObserver]', standalone: true })
export class ResizeObserverDirective implements OnDestroy, OnInit {
  @Output()
  resized: EventEmitter<ResizeObserverEntry> = new EventEmitter<ResizeObserverEntry>();

  private resizeObserver: ResizeObserver;

  @Input()
  appResizeObserver: Element;

  constructor(
    private readonly element: ElementRef,
    private readonly zone: NgZone,
  ) {}

  ngOnInit(): void {
    const ResizeObserver = window.ResizeObserver || ResizePolyfill;
    this.resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      entries.forEach((e: ResizeObserverEntry) => this.zone.run(() => this.resized.next(e)));
    });
    this.resizeObserver.observe(this.appResizeObserver ? this.appResizeObserver : this.element.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
